import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IDashboardState } from './dashboard.reducer';

const dashboardSelector = createFeatureSelector<IDashboardState>('dashboard');
export const getDashoardWidgets = createSelector(dashboardSelector, (state) => state.widgets);
export const isDashboardPending = createSelector(dashboardSelector, (state) => state.pending);
export const isDashboardInitiated = createSelector(dashboardSelector, (state) => state.initiated);

export const dashboardQuery = {
  getDashoardWidgets,
  isDashboardPending,
  isDashboardInitiated,
};
